module.exports = __webpack_public_path__ + "static/img/360js_img_1.d5c2238b.png";